import { combineReducers } from 'redux';

import limits from './limits';
import loadingStatus from './loadingStatus';
import period from './period';
import permissions from './permissions';
import permissionsAndLimitsLoadingStatus from './permissionsAndLimitsLoadingStatus';
import usages from './usages';

const userAuthorityReducer = combineReducers({
  limits,
  loadingStatus,
  period,
  permissions,
  permissionsAndLimitsLoadingStatus,
  usages,
});

export default userAuthorityReducer;

export type UserAuthorityState = ReturnType<typeof userAuthorityReducer>;
